import Cookies from 'universal-cookie';

import fetchHelper from "./FetchHelper.js";
import utmHelper from "./UtmHelper.js";
import {apiUrl} from "../config.js";
import { bigBrotherEvents as sendBigBrotherEvents } from './CommonHelper';

const apiHelper = new fetchHelper();
const utmParams = new utmHelper();
    
export const getSimilarAds = (adId) => {
    return new Promise(
        function (resolve, reject) {
            let params = {
                url: `${apiUrl}/vap/get-relevant-ads/?aj=1&adId=${adId}`
            };

            apiHelper.request('get', params).then((response) => {
                resolve(response);
            });
        }
    )
}

export const getPeopleAlsoViewedAds = (adId) => {
    return new Promise(
        function (resolve, reject) {
            let params = {
                url: `${apiUrl}/vap/people-also-viewed-ads/?aj=1&adId=${adId}`
            };

            apiHelper.request('get', params).then((response) => {
                resolve(response);
            });
        }
    )
}

export const sendGetContactReq = (name,email,mobile,csrf,adId) => {
    return new Promise(
        function (resolve, reject) {
            const data = {
                adId: adId,
                mobile: mobile,
                emailId: email,
                name: name,
                leadType: "CALL",
                campaignName: "RESPONSE_CALL",
                campaignId: "RESPONSE_CALL",
                captureSource: "VAP",
                CSRFKey: csrf.key,
                CSRFValue: csrf.value
            }
            let params = {
                url: `${apiUrl}/ad-owner-contact-details/get-contact-details?isAjaxRequest=true&_t=${csrf.ftoken}`,
                data: data,
                isJson: true
            };
            apiHelper.request('POST', params).then((response) => {
                resolve(response);
            });
        }
    )
}

export const sendReq = (name,email,mobile,csrf,adId) => {
    return new Promise(
        function (resolve, reject) {
            const data = {
                adId: adId,
                mobile: mobile,
                emailId: email,
                name: name,
                leadType: "CALL",
                campaignName: "RESPONSE_CALL",
                campaignId: "RESPONSE_CALL",
                captureSource: "VAP"
            }
            let params = {
                url: `${apiUrl}/ad-owner-contact-details/get-ad-owner-contact-details?_t=${csrf.ftoken}`,
                data: data,
                isJson: true
            };

            apiHelper.request('POST', params).then((response) => {
                resolve(response);
            });
        }
    )
}

export const pushVapDataToDataLayer = (data,user,deviceType) => {
    const cookies = new Cookies();
    const { adData, categoryGid, categoryPGid, subCategoryName } = data;
    let isPremium = (data.adStyle == "PREMIUM") ? true : false;
    let utmParameters = utmParams.getUtmParameters();
    let dataToPush = {
        "Ad_id":adData.adId,
        "lang":"English",
        "USER_CITY_NAME":adData.cityName,
        "Category_id":categoryPGid,
        "SubCategory_id":categoryGid,
        "SubCategory_Name":subCategoryName,
        "Category_Name":"Cars-Bikes",
        "USER_CITY_ID":adData.cityId,
        "referrer":document.referrer,
        "utmSource":utmParameters.utm_source,
        "utmMedium":utmParameters.utm_medium,
        "utmCampaign":utmParameters.utm_campaign,
        "deviceType":deviceType,
        "locality":adData.adLocality,
        "brand":adData.attributeData.Brand_name,
        "model":adData.attributeData.Model,
        "variant":adData.attributeData.Variant,
        "priceOfVehicle":adData.price,
        "kmsDriven":adData.attributeData.Kms_Driven,
        "yearOfRegn":adData.attributeData.Year,
        "isPremium": isPremium,
        "isAssured": adData.attributeData.adOfferingType === 'assured',
        "isPreferredSeller": adData.attributeData.adOfferingType === 'preferredSeller',
        "isInspected": adData.attributeData.adOfferingType === 'inspected',
        "emiTest": adData.emiEnabled,
        "PAGE_TYPE":"VAP"
    };

    if (adData.attributeData.Fuel_Type) {
        dataToPush.Fuel_Type = adData.attributeData.Fuel_Type;
    }

    if (categoryGid == 72) {
        dataToPush.Bike_Type = adData.attributeData.Bike_Type;
    }

    if(user.loggedIn){
        const { name , email , mobile } = user;
        dataToPush.name = name;
        dataToPush.email = email;
        dataToPush.mobile = mobile;
        dataToPush.userId = cookies.get("__u");
        dataToPush.isLoggedIn = 1;
    } else {
        dataToPush.isLoggedIn = 0;
    }
    
    if(typeof dataLayer != "undefined" && dataLayer){
        dataLayer.push(dataToPush);
    }
}

export const loadQDFP = (vapData,IsLoggedIn,channel) => {
    const { adData, metaCategoryName, subCategoryName } = vapData;
    let script = document.createElement("script");
    script.innerHTML = "window.qdfp_vp={id: 'old_vap_page',ptargeting: [{key:'City',value: '"+adData.cityName+"'},{key: 'Category',value: '"+metaCategoryName+"'},{key: 'Subcategory',value:'"+ subCategoryName+"'},{key: 'Brand_name',value:  '"+adData.attributeData.Brand_name+"'},{key: 'Model',value:'"+  adData.attributeData.Model+"'},{key: 'Price',value:'"+  adData.attributeData.Price+"'},{key: 'isLoggedIn',value:"+ Number(IsLoggedIn)+" }]}";
    document.head.appendChild(script);

    let imported = document.createElement('script');
    imported.src = `https://teja9.kuikr.com/public/mon/qapqdfp/cars_4.0.0/cnb/${(channel == 'desktop') ? 'index.js' : 'index-msite.js'}`;
    document.body.appendChild(imported);
}

export const bigBrotherEvents = (vapData,event,channel) => {
    const cookies = new Cookies();
    const { adData, categoryGid, subCategoryName } = vapData;
    var postData = {
        "user_db_id":cookies.get("__u"),
        "ad_id":adData.adId,
        "cat_id":60,
        "cat_name":"Cars-Bikes",
        "subcat_id": categoryGid,
        "subcat_name": subCategoryName,
        "city_id": adData.cityId,
        "city_name": adData.cityName
    }
    sendBigBrotherEvents(postData,event,channel);
}

export const sendOtp = (mobile,csrf) => {
    return new Promise((resolve,reject) => {
        let apiUrl = 'https://www.quikr.com/core/quikrcom/ad-owner-contact-details/send-otp?isAjaxRequest=true&_t='+ csrf.ftoken
        let data = new URLSearchParams();
        data.append('user', mobile);
        data.append('CSRFKey', csrf.key);
        data.append('CSRFValue', csrf.value);

        let params = {
            url: apiUrl,
            data: data
        };

        apiHelper.request('POST', params).then((response) => {
            resolve(response);
        })
    })
}

export const resendOtp = (csrf) => {
    return new Promise((resolve,reject) => {
        let apiUrl = 'https://www.quikr.com/core/quikrcom/ad-owner-contact-details/resend-otp?isAjaxRequest=true&_t='+ csrf.ftoken
        let data = new URLSearchParams();
        data.append('CSRFKey', csrf.key);
        data.append('CSRFValue', csrf.value);

        let params = {
            url: apiUrl,
            data: data
        };

        apiHelper.request('POST', params).then((response) => {
            resolve(response);
        })
    })
}

export const verifyOtp = (otp,mobile,csrf) => {
    return new Promise((resolve,reject) => {
        let apiUrl = 'https://www.quikr.com/core/quikrcom/ad-owner-contact-details/verify-otp?isAjaxRequest=true&_t=' + csrf.ftoken

        let data = new URLSearchParams();
        data.append('otp', otp);
        data.append('GreetingName', mobile);
        data.append('CSRFKey', csrf.key);
        data.append('CSRFValue', csrf.value);

        let params = {
            url: apiUrl,
            data: data
        };

        apiHelper.request('POST', params).then((response) => {
            resolve(response);
        })
    })
}



// WEBPACK FOOTER //
// ../q-cars/src/utils/VapHelper.js